<template>
  <div>
    <div id="container">
      <img src="../assets/close.svg" class="icon" id="close-icon" v-on:click="close">
      <div id="main-title">Thank You!</div>
      <p class="description">
        It may take a few hours for your<br>
        business to appear on the map.
      </p>
      <hr>
      <p class="description">
        If you have questions, issues or<br>
        suggestions, please contact us:<br>
        <b>contact@supportbiznow.com</b>
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ThankYou",
    methods: {
      close() {
        this.$emit('hide')
      }
    }
  }
</script>

<style scoped>
  #container {
    width: 420px;
    margin: 200px auto 0 auto;
    padding: 0 30px 50px 30px;
    background-color: white;
    color: black;
    position: relative;
    -moz-box-shadow: 0 0 30px #151515;
    -webkit-box-shadow: 0 0 30px #151515;
    box-shadow: 0 0 30px #151515;
  }
  #close-icon {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }
  #close-icon:hover {
    opacity: 0.8;
  }
  #main-title {
    font-family: "Avenir Next", serif;
    font-weight: bold;
    font-size: 34px;
    margin-top: 60px;
    margin-bottom: 20px;
    display: inline-block;
    color: #232A2E;
  }
  .description {
    font-family: "Avenir Next", serif;
    font-weight: 500;
    font-size: 20px;
    text-align: center;
    margin-top: 30px;
    width: 100%;
  }
  hr {
    margin-top: 30px;
    width: 27%;
    border: none;
    background-color: #CE6363;
    height: 1px;
  }

  /*MOBILE*/
  @media only screen and (max-width: 768px) {
    #container {
      width: 94%;
      margin: 60px auto 0 auto;
      padding-bottom: 40px;
    }
    #main-title {
      font-size: 30px;
      margin-top: 50px;
    }
    .description {
      font-size: 16px;
      margin: 20px auto 0 auto;
      width: 90%;
    }
  }
</style>